/**
 * Exports assessment data to a JSON file
 * @param {Object} assessmentData - The assessment data to export
 */
export const exportAssessment = (assessmentData) => {
    try {
      // Add metadata to export
      const exportData = {
        version: "1.0",
        exportDate: new Date().toISOString(),
        assessment: assessmentData
      };
  
      // Create and trigger download
      const json = JSON.stringify(exportData, null, 2);
      const blob = new Blob([json], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${assessmentData.name}-export.json`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
  
      return true;
    } catch (error) {
      console.error('Export failed:', error);
      alert('Failed to export assessment');
      return false;
    }
  };
  
  /**
   * Imports assessment data from a JSON file
   * @param {File} file - The JSON file to import
   * @returns {Promise} - Resolves with imported data
   */
  export const importAssessment = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      
      reader.onload = (e) => {
        try {
          const data = JSON.parse(e.target.result);
          if (!data.assessment || !data.assessment.name) {
            throw new Error('Invalid assessment data format');
          }
          resolve(data.assessment);
        } catch (error) {
          reject(new Error('Failed to parse assessment file'));
        }
      };
  
      reader.onerror = () => reject(new Error('Failed to read file'));
      reader.readAsText(file);
    });
  };
  
  /**
   * Merges imported assessment with existing ones
   * @param {Object} importedAssessment - The assessment to import
   * @param {Array} existingAssessments - Current assessments array
   * @returns {Array} - Updated assessments array
   */
  export const mergeAssessment = (importedAssessment, existingAssessments) => {
    // Check for duplicates
    const isDuplicate = existingAssessments.some(a => a.name === importedAssessment.name);
    
    if (isDuplicate) {
      importedAssessment.name = `${importedAssessment.name} (Imported)`;
    }
    
    return [...existingAssessments, importedAssessment];
  };